const registration = "https://api.envimap.hu/api/v1/users/register"

export const Registration = async (body, setModalType) => {
  await fetch(registration, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((actualData) => {
      if (actualData.status === 200) return setModalType("registrationSuccess")
    })
    .catch((error) => console.log(error))
}